/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../../models/Models/v4/Application/application-response-base-response';
import { PublicApplicationStartRequest as ModelsV4ApplicationPublicPublicApplicationStartRequest } from '../../models/Models/v4/Application/Public/public-application-start-request';

export interface V4PublicApplicationVehiclePost$Xml$Xml$Params {
      body?: ModelsV4ApplicationPublicPublicApplicationStartRequest
}

export function v4PublicApplicationVehiclePost$Xml$Xml(http: HttpClient, rootUrl: string, params?: V4PublicApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationVehiclePost$Xml$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>;
    })
  );
}

v4PublicApplicationVehiclePost$Xml$Xml.PATH = '/v4/public/application/vehicle';
